<template>
  <v-app light>
    <app-header></app-header>
    <v-content>
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </v-content>
    <app-global-progress></app-global-progress>
    <app-global-snackbar></app-global-snackbar>
    <app-global-dialog></app-global-dialog>
    <app-footer v-if="user" :user="user"></app-footer>
  </v-app>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import GlobalProgress from "@/components/GlobalProgress";
import GlobalSnackbar from "@/components/GlobalSnackbar";
import { mapGetters } from "vuex";
export default {
  name: "App",
  components: {
    appHeader: Header,
    appFooter: Footer,
    appGlobalProgress: GlobalProgress,
    appGlobalSnackbar: GlobalSnackbar
  },
  computed: {
    ...mapGetters(["user"])
  }
};
</script>

<style>
.cropper-background {
  background: white;
}
table.v-table {
  max-width: none;
}
</style>
